import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/targets/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Outegration'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
